export default __webpack_public_path__ + "static/media/TempControllerIcon.30255f09.svg";